<template>
  <v-form v-bind="this.$attrs">
    <v-row class="flex-center-between">
      <v-col cols="12" sm="6" md="3">
        <div class="text mb-2">Kỳ lương</div>
        <div class="text-name">{{ period.title | convertFullDate }}</div>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <div class="text mb-2">Trạng thái</div>
        <v-chip small class="white--text" :color="statusColor()" label>
          <span class="white--text">{{ status() }}</span>
        </v-chip>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <div class="text mb-2">Tổng kết lần cuối</div>
        <div class="text-name" v-if="period.status !== 'created'">
          {{ period.updatedAt | ddmmyyyyhhmm }}
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <div class="text mb-2">Người thực hiện</div>
        <div class="text-name" v-if="period.status !== 'created'">
          {{ period.generatedBy ? period.generatedBy.name : '' }}
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      period: 'salaryPeriod/period',
    }),
  },
  methods: {
    ...mapMutations({
      resetDataReport: 'salaryReport/resetData',
      resetDataPeriod: 'salaryPeriod/resetData'
    }),
    statusColor() {
      return this.$utils.statusPeriodToColor(this.period.status)
    },
    status() {
      return this.$utils.statusPeriodToText(this.period.status)
    },
  },
  created() {
    this.resetDataReport()
    this.resetDataPeriod()
  }
}
</script>
<style scoped>
.text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #797979;
}

.text-name {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #000000;
}
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: max-content;
  max-width: 100%;
}
.tooltip {
  word-wrap: break-word;
}
</style>
